"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
// Relements
var box_1 = __importDefault(require("relements/build/esm/ui/box"));
var text_1 = __importDefault(require("relements/build/esm/ui/text"));
var icon_1 = __importDefault(require("relements/build/esm/ui/icon"));
var button_1 = __importDefault(require("relements/build/esm/ui/button"));
// Components
var FAQUpload_1 = __importDefault(require("../FAQUpload"));
// Icon
var FAQEmptyList_svg_1 = __importDefault(require("../../icons/FAQEmptyList.svg"));
var EmptyCardWrapper = styled_components_1["default"](box_1["default"])({
    padding: 0,
    width: '100%',
    height: 'calc(100vh - 150px)',
    justifyContent: 'center',
});
var EmptyCard = styled_components_1["default"](box_1["default"])({
    padding: 0,
    margin: 'auto',
    flexDirection: 'column',
    alignItems: 'center',
    maxWidth: 457,
});
var IconWrapper = styled_components_1["default"](icon_1["default"])({
    width: 144,
    height: 144,
    pointerEvents: 'none',
});
var TextWrapper = styled_components_1["default"](text_1["default"])({
    fontSize: 16,
    margin: '24px 0px',
    textAlign: 'center',
});
var ButtonWrapper = styled_components_1["default"](button_1["default"])({
    width: 198,
    height: 36,
    marginTop: 12,
});
var EmptyNodes = function (_a) {
    var onAddNodeClick = _a.onAddNodeClick;
    return (react_1["default"].createElement(EmptyCardWrapper, null,
        react_1["default"].createElement(EmptyCard, null,
            react_1["default"].createElement(IconWrapper, { src: FAQEmptyList_svg_1["default"] }),
            react_1["default"].createElement(TextWrapper, null, "You can create multiple FAQ steps that answer general questions about the Bot domain."),
            react_1["default"].createElement(box_1["default"], { padding: "zero", width: "198px", height: "36px" },
                react_1["default"].createElement(FAQUpload_1["default"], { isEmptyList: true })),
            react_1["default"].createElement(ButtonWrapper, { size: "regular", themed: true, variant: "secondary", onClick: onAddNodeClick }, "Add FAQ Step Manually"))));
};
exports["default"] = EmptyNodes;
